module.exports = __webpack_public_path__ + "static/media/ph.samokell.bccbc4fc.jpg";